module.exports = __webpack_public_path__ + "static/the-making-of-europe-87b73f0f68986d1263a8ec26284521eb.jpg";